import {
  IApiResponse,
  IClinicalTrialDataBase,
  IClinicalTrialDelete,
  IClinicalTrialPatch,
  IClinicalTrialPost,
  IClinicalTrialResponse,
  IClinicalTrialResponseV2
} from 'types'
import { BASE_CLINICAL_TRIAL } from './CONSTANTS'
import { request } from 'services/base'

export const getClinicalTrialInfo = async (
  data?: IClinicalTrialDataBase
): Promise<IApiResponse<IClinicalTrialResponse>> => {
  const response = await request<IClinicalTrialResponseV2>({
    url: BASE_CLINICAL_TRIAL,
    params: data,
    method: 'get'
  })

  const transformedData: IApiResponse<IClinicalTrialResponse> = {
    ...response,
    data: response.data
      ? {
          ...response.data,
          status: response.data.status
        }
      : undefined
  }

  return transformedData
}

export const deleteClinicalTrialInfo = async (
  data?: IClinicalTrialDelete
): Promise<IApiResponse<IClinicalTrialResponse>> =>
  await request({ url: BASE_CLINICAL_TRIAL, data: data, method: 'delete' })

export const updateClinicalTrialInfo = async (
  data?: IClinicalTrialPatch
): Promise<IApiResponse<IClinicalTrialResponse>> =>
  await request({ url: BASE_CLINICAL_TRIAL, data: data, method: 'patch' })

export const postClinicalTrialInfo = async (
  data?: IClinicalTrialPost
): Promise<IApiResponse<IClinicalTrialResponse>> =>
  await request({ url: BASE_CLINICAL_TRIAL, data: data, method: 'post' })
